import {
  EyeClosedIcon,
  EyeOpenIcon,
  RegisterAsGroupIcon,
  RegisterAsIndividualIcon,
} from "@/assets";
import { AsarButton, AsarFormikInput, Loader } from "@/components";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { Form, Formik } from "formik";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { postUserSignin } from "../../api/signin";
import { setToken } from "../../api/token";
import LockIcon from "../../assets/SVG/lockIcon";
import ProfileIcon from "../../assets/SVG/profileIcon";

export default function LoginForm() {
  const [showPassword, setShowPassword] = useState(false);
  const [showSignupModal, setShowSignupModal] = useState(false);
  const md = useMediaQuery("(max-width:450px)");
  const navigate = useNavigate();

  const onSubmit = async (values, actions) => {
    postUserSignin({
      nid: values.username,
      password: values.password,
    })
      .then((res) => {
        setToken(res);
        navigate("/dashboard");
      })
      .catch(() => {})
      .finally(() => actions.setSubmitting(false));
  };

  return (
    <>
      <Formik
        onSubmit={onSubmit}
        initialValues={{}}
        // validationSchema={{}}
        validateOnBlur={false}
        validateOnChange={false}
        validateOnMount={false}
      >
        {({ isSubmitting, submitForm }) => (
          <Form
            style={{ width: "100%", display: "flex", flexDirection: "column" }}
          >
            <Grid
              display={"flex"}
              flexDirection={"column"}
              alignItems={"center"}
              gap={"16px"}
            >
              <AsarFormikInput
                maxLength={10}
                inputMode="numeric"
                name={"username"}
                label="کدملی"
                placeholder={"کدملی خود را بنویسید"}
                startAdornment={<ProfileIcon />}
              />
              <AsarFormikInput
                type={showPassword ? "text" : "password"}
                name={"password"}
                label="رمز عبور"
                placeholder={"رمز عبور خود را بنویسید"}
                showResetPassword={true}
                startAdornment={<LockIcon />}
                endAdornment={
                  <IconButton
                    onClick={() => setShowPassword(!showPassword)}
                    edge="end"
                    aria-label={showPassword ? "مخفی کردن رمز" : "نمایش رمز"}
                  >
                    {showPassword ? <EyeClosedIcon /> : <EyeOpenIcon />}
                  </IconButton>
                }
              />

              <AsarButton style={{ marginTop: "30px" }} onClick={submitForm}>
                ورود به حساب
              </AsarButton>
              {isSubmitting && <Loader />}
            </Grid>
          </Form>
        )}
      </Formik>

      <Box display="flex" justifyContent="center" mt="10px">
        <Typography sx={{ fontSize: "16px", color: "var(--emr-text-bold)" }}>
          آیا حساب فعالی ندارید؟
        </Typography>
        <Link onClick={() => setShowSignupModal(true)}>
          <Typography
            sx={{
              fontSize: "16px",
              color: "var(--emr-primary)",
              mr: "5px",
              cursor: "pointer",
            }}
          >
            ثبت نام کنید
          </Typography>
        </Link>
      </Box>
      <Dialog
        open={showSignupModal}
        onClose={() => setShowSignupModal(false)}
        maxWidth="lg"
      >
        <DialogTitle sx={{ m: md ? "4px" : "16px" }}>
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: md ? "14px" : "20px",
              textAlign: "center",
              m: "auto",
            }}
          >
            کدام نوع ثبت نام را انتخاب میکنید؟
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Grid
            display={"flex"}
            flexDirection={"row"}
            gap={"10px"}
            flexWrap={"wrap"}
            sx={{ m: "auto", width: "fit-content" }}
          >
            <Grid
              display={"flex"}
              className="rounded-xl"
              flexDirection={"column"}
              justifyContent={"center"}
              alignItems={"center"}
              alignContent={"center"}
              gap={"20px"}
              sx={{
                backgroundColor: "var(--emr-background-silver)",
                padding: "12px 24px",
                width: md ? "240px" : "340px",
              }}
            >
              <Grid
                display={"flex"}
                flexDirection={"column"}
                justifyContent={"center"}
                alignContent={"center"}
                alignItems={"center"}
                sx={{
                  border: `2px solid var(--emr-primary)`,
                  borderRadius: "50%",
                  width: 48,
                  height: 48,
                  m: md ? "8px" : "16px",
                }}
              >
                <RegisterAsGroupIcon />
              </Grid>
              <Typography
                sx={{ fontWeight: 600, color: "var(--emr-text-bold)" }}
              >
                ثبت نام گروه جهادی
              </Typography>
              <Typography
                sx={{
                  color: "var(--emr-text)",
                  textAlign: "center",
                  fontSize: "12px",
                }}
              >
                آیا قصد دارید از سامانه اردو جهادی اثر برای گروه جهادی خود
                استفاده کنید؟
              </Typography>
              <AsarButton onClick={() => navigate("/signup/group")}>
                ثبت نام گروه
              </AsarButton>
            </Grid>
            <Grid
              display={"flex"}
              className="rounded-xl"
              flexDirection={"column"}
              justifyContent={"center"}
              alignItems={"center"}
              alignContent={"center"}
              gap={"20px"}
              sx={{
                backgroundColor: "var(--emr-background-silver)",
                padding: "12px 24px",
                width: md ? "240px" : "340px",
              }}
            >
              <Grid
                display={"flex"}
                flexDirection={"column"}
                justifyContent={"center"}
                alignContent={"center"}
                alignItems={"center"}
                sx={{
                  border: `2px solid var(--emr-primary)`,
                  borderRadius: "50%",
                  width: 48,
                  height: 48,
                  m: md ? "8px" : "16px",
                }}
              >
                <RegisterAsIndividualIcon />
              </Grid>
              <Typography
                sx={{ fontWeight: 600, color: "var(--emr-text-bold)" }}
              >
                ثبت نام جهادگر
              </Typography>
              <Typography
                sx={{
                  color: "var(--emr-text)",
                  textAlign: "center",
                  fontSize: "12px",
                }}
              >
                جهادگر هستید و می‌خواهید از سامانه اردو جهادی اثر بهره‌مند شوید؟
              </Typography>
              <AsarButton onClick={() => navigate("/signup/person")}>
                ثبت نام جهادگر
              </AsarButton>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
}
